import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../GlobalCss/globalStyle.css";

const CustomDropDownMenu = ({ 
  Element, 
  data, 
  content = undefined, 
  Action = false, 
  show = false, 
  onSelect = (x) => {} 
}) => {
  let imgClass = "Icon20";

  return (
    <>
      {show ? (
        <Dropdown show={show}>
          <Dropdown.Toggle
            style={{ outline: "none", height: Action && "20px" }}
            variant="none"
            id="filterDropdown"
            className="m-0"
          >
            {Element}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {content && <div className="custom-content">{content}</div>}
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <Dropdown className="d-flex align-items-center actionsDropdownContainer clickable">
          <Dropdown.Toggle
            variant="none"
            className="m-0 actionsDropdownToggle"
          >
            {Action ? (
              <div className="d-flex gap-2 align-item-center justify-content-center pe-2 ps-2">
                <p className="sub_text fw-600 blue">Actions</p>
                {Element}
              </div>
            ) : (
              Element
            )}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {content ? (
              <div className="custom-content">{content}</div>
            ) : (
              data?.map((item, index) => (
                <React.Fragment key={item.id}>
                  <Dropdown.Item 
                    onClick={() => {
                      if (item.onClick) item.onClick();
                      onSelect(item); 
                    }}
                  >
                    {item.linkpath ? (
                      <Link
                        to={item.linkpath}
                        className="text-decoration-none d-flex flex-row align-items-center text-dark gap-2"
                      >
                        {item.img && (
                          <img
                            src={item.img}
                            className={item.imgClass || imgClass}
                            alt="Icon"
                          />
                        )}
                        <p className={item.textClass || "sub-text"}>
                          {item.name}
                        </p>
                      </Link>
                    ) : (
                      <div className="text-decoration-none d-flex flex-row align-items-center text-dark gap-2">
                        {item.img && (
                          <img
                            src={item.img}
                            className={(item.imgClass || imgClass) + " black-white-icon"}
                            alt="Icon"
                          />
                        )}
                        <p className={item.textClass || "sub-text"}>
                          {item.name}
                        </p>
                      </div>
                    )}
                  </Dropdown.Item>
                  {index !== data.length - 1 && <Dropdown.Divider />}
                </React.Fragment>
              ))
            )}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
};

export default CustomDropDownMenu;
